import { getStyledElement } from "@/helpers";
import { IonAlert } from "@ionic/react";

export const Alert = getStyledElement(IonAlert)({
  styles: () => ({
    "--max-width": "auto",
    padding: "10px"
  })
});
